import React, { useEffect, useState } from "react";
import Button from "./ui/Button";
import {
  OPEN_CONSENT_PREFERENCES_EVENT,
  getStoredConsent,
  initializeStoredConsent,
  saveConsent,
} from "../utils/analytics";

const AnalyticsConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!visible) return undefined;
    const banner = document.querySelector(".analytics-consent-banner");
    if (!banner) return undefined;
    const update = () => document.documentElement.style.setProperty("--consent-banner-height", `${banner.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(banner);
    return () => { observer.disconnect(); document.documentElement.style.removeProperty("--consent-banner-height"); };
  }, [visible]);

  useEffect(() => {
    const storedConsent = initializeStoredConsent();
    const rafId = window.requestAnimationFrame(() => setVisible(!storedConsent));
    const openPreferences = () => setVisible(true);
    window.addEventListener(OPEN_CONSENT_PREFERENCES_EVENT, openPreferences);
    return () => {
      window.cancelAnimationFrame(rafId);
      window.removeEventListener(OPEN_CONSENT_PREFERENCES_EVENT, openPreferences);
    };
  }, []);

  const handleAnalyticsChoice = (analytics) => {
    saveConsent({
      analytics,
      marketing: getStoredConsent()?.marketing === true,
    });
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <aside
      className="analytics-consent-banner fixed inset-x-0 bottom-0 z-50 border-t border-border/80 bg-card/95 px-3 py-1.5 backdrop-blur-xs sm:px-6 sm:py-2"
      aria-label="Analytics consent"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 sm:gap-3">
        <p className="min-w-0 text-body-xs leading-snug text-foreground/75 sm:text-body-small">
          <span className="hidden sm:inline">Optional analytics: Google Analytics sets cookies that measure how the site is used. Declining sets none. </span>
          <span className="sm:hidden">Optional cookies measure site use. </span>
          <a className="font-medium text-secondary-readable underline-offset-2 hover:underline" href="/privacy">
            Privacy policy
          </a>
        </p>
        <div className="flex shrink-0 gap-1 sm:gap-2">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="analytics-consent-banner__button"
            onClick={() => handleAnalyticsChoice(false)}
          >
            Decline
          </Button>
          <Button
            type="button"
            size="sm"
            className="analytics-consent-banner__button"
            onClick={() => handleAnalyticsChoice(true)}
          >
            Allow analytics
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default AnalyticsConsentBanner;
